import form from './src/form.vue'

export * from './types'

export default form
